import React from "react";
import PT from "prop-types";
import { Content } from "_c/Modals";
import Upload from "./Upload";
import PhotosList from "./List";
import QueryRequest from "@/components/QueryRequest";
import { useTaskPhotosQuery } from "../../hooks/usePhotosQuery";

const TaskPhotos = (props) => {
  const query = useTaskPhotosQuery({
    taskId: props.task._id,
    enabled: true,
  });
  return (
    <Content
      css={`
        color: var(--font-color-main);
      `}
    >
      <QueryRequest query={query}>
        <>
          <PhotosList task={props.task} t={props.t} photos={query.data} />
          <Upload
            task={props.task}
            t={props.t}
            photos={query.data}
            isTaskMaster={props.isTaskMaster}
            isTaskConsumer={props.isTaskConsumer}
          />
        </>
      </QueryRequest>
    </Content>
  );
};
TaskPhotos.propTypes = {
  task: PT.object.isRequired,
  isTaskMaster: PT.bool,
  isTaskConsumer: PT.bool,

  t: PT.func.isRequired,
};
export default TaskPhotos;
